import { AsesoriaWidget, type WidgetConfig } from './widget.js';

declare global {
  interface Window {
    AsesoriaChatbotConfig?: WidgetConfig;
    AsesoriaChatbot?: AsesoriaWidget;
  }
}

function init() {
  const cfg = window.AsesoriaChatbotConfig;
  if (!cfg) {
    console.warn('[Asesoría chatbot] window.AsesoriaChatbotConfig no definido. Widget no inicializado.');
    return;
  }
  if (!cfg.businessId || !cfg.apiUrl) {
    console.warn('[Asesoría chatbot] businessId y apiUrl son obligatorios.');
    return;
  }
  try {
    const u = new URL(cfg.apiUrl);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') throw new Error('protocol');
  } catch {
    console.warn('[Asesoría chatbot] apiUrl no es una URL http(s) válida. Widget no inicializado.');
    return;
  }
  if (window.AsesoriaChatbot) return; // ya inicializado
  window.AsesoriaChatbot = new AsesoriaWidget(cfg);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
